import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {CustomFormControl} from '../components/controls/CustomFormControl';
import {FieldEqualityValidation} from '../models/WebFormTemplate';

export function equalityValidator(validation: FieldEqualityValidation, controls: Map<string, CustomFormControl>): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const targetControl = controls.get(validation.targetControlId);
    if (!targetControl) { return; }

    const areEqual = targetControl.value.toLowerCase() === control.value.toLowerCase();
    if (validation.successIf === 'equal') {
      return areEqual ? null : { inequality: validation.customErrorMessage };
    }

    return validation.successIf === 'notEqual' && !areEqual ? null : { inequality: validation.customErrorMessage };
  };
}
